const cloneOverrideRecord = (value: Record<string, unknown>) =>
  (typeof structuredClone === 'function'
    ? structuredClone(value)
    : JSON.parse(JSON.stringify(value))) as Record<string, unknown>;

const NUMERIC_PAINT_PROPS = new Set<string>([
  'fill-opacity',
  'line-blur',
  'line-gap-width',
  'line-offset',
  'line-opacity',
  'line-width',
  'circle-blur',
  'circle-opacity',
  'circle-radius',
  'circle-stroke-opacity',
  'circle-stroke-width',
  'icon-halo-width',
  'icon-halo-blur',
  'icon-opacity',
  'text-opacity',
  'text-halo-width',
  'text-halo-blur',
  'fill-extrusion-base',
  'fill-extrusion-height',
  'fill-extrusion-opacity',
]);

const NUMERIC_LAYOUT_PROPS = new Set<string>([
  'fill-sort-key',
  'line-miter-limit',
  'line-round-limit',
  'line-sort-key',
  'circle-sort-key',
  'symbol-spacing',
  'symbol-sort-key',
  'icon-size',
  'icon-rotate',
  'icon-padding',
  'text-size',
  'text-max-width',
  'text-line-height',
  'text-letter-spacing',
  'text-radial-offset',
  'text-max-angle',
  'text-rotate',
  'text-padding',
]);

const normalizeNumericOverrideRecord = (
  value: Record<string, unknown> | null | undefined,
  numericProps: Set<string>,
) => {
  if (!value) {
    return null;
  }

  const next = cloneOverrideRecord(value);
  Object.entries(next).forEach(([prop, entryValue]) => {
    if (!numericProps.has(prop)) {
      return;
    }
    if (typeof entryValue === 'number') {
      if (!Number.isFinite(entryValue)) {
        delete next[prop];
      }
      return;
    }
    if (typeof entryValue === 'string') {
      const trimmed = entryValue.trim();
      if (!trimmed) {
        delete next[prop];
        return;
      }
      const numericValue = Number(trimmed);
      if (Number.isFinite(numericValue)) {
        next[prop] = numericValue;
      } else {
        delete next[prop];
      }
      return;
    }
    if (Array.isArray(entryValue)) {
      return;
    }
    if (entryValue && typeof entryValue === 'object') {
      return;
    }
    delete next[prop];
  });

  return next;
};

export const normalizeMapLibrePaintOverrides = (value: Record<string, unknown> | null | undefined) =>
  normalizeNumericOverrideRecord(value, NUMERIC_PAINT_PROPS);

export const normalizeMapLibreLayoutOverrides = (value: Record<string, unknown> | null | undefined) =>
  normalizeNumericOverrideRecord(value, NUMERIC_LAYOUT_PROPS);
